import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Constant } from './constants';
import { Observable, BehaviorSubject, of, Subject } from 'rxjs';
import * as fromModel from './models';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ActivatedRoute } from '@angular/router';


export class UserDetail {
  name = '';
  userid = '';
  poolIds = '';
  repId = '';
  simulateRepIds = '';
  role = fromModel.USERROLE.PA;
}
@Injectable({
  providedIn: 'root'
})
export class UserService {
  appInsights: ApplicationInsights = new ApplicationInsights({ config: { instrumentationKey: Constant.config.appInsightKey } });

  private sessionId = '';
  private app: string = 'Supervision Tool -> ';
  private step = 0;
  private user: UserDetail | undefined;
  private simUser: UserDetail | undefined;

  public userSubject = new BehaviorSubject<UserDetail | undefined>(undefined);
  
  private isdatamarkingon = false;

  constructor(private _httpClient: HttpClient,
    private route: ActivatedRoute,
  ) {
    const _hash = window.location.hash;
    if (_hash && _hash.trim().toUpperCase().includes("DATAMASK=Y") || _hash.trim().toUpperCase().includes("DATAMASK='Y'")) {
      this.isdatamarkingon = true;
    }
    this.sessionId = (new Date()).getTime().toString();
    this.app += ' Session Id:' + this.sessionId + ' ';
  }


  setUser(u: UserDetail) {
    this.user = u;
    this.userSubject.next(u);
  }

  setSimUser(role: fromModel.USERROLE) {
    this.simUser = JSON.parse(JSON.stringify(this.user));
    if (this.simUser) {
      this.simUser.role = role;
      this.userSubject.next(this.simUser);
    }
  }

  getUser(): UserDetail | undefined {
    return this.user;
  }

  setdatamasking(val: boolean) {
    this.isdatamarkingon = val;
  }
  getdatamasking(): boolean {
    return this.isdatamarkingon;
  }

  getTestData(): Observable<any> {
    const d: any = {
      actNo: 'RJM',
      mktVal: 123456,
      owner: 'Test Client',
      actType: 'Test Account Type',
      state: 'NJ',
      taxStatus: 'Taxable',
      turnOver: 6
    };
    let _data: any[] = [];
    for (let i = 0; i < 10000; i++) {
      let k = Object.assign({}, d);
      k.actNo = k.actNo + i.toString();
      _data.push(k);
    }
    return of(_data);
  }


  

  // -------- Tracing -------------
  // Information, Verbose, Warning, Error, Critical
  traceMsg(msg: string, detail?: any, level: string = "Information"): void {

    this.step = this.step + 1;
    // this.appInsightsService.trackTrace(this.app + msg, {
    //   'userId': this.user?.userid || '', 'sessionId': this.sessionId, 'step': this.step.toString(),
    //   'datail': JSON.stringify(detail)
    // }, SeverityLevel.Information);

    this.appInsights.trackTrace({ message: this.app + msg }, { 'userId': this.user?.userid, 'sessionId': this.sessionId, 'datail': JSON.stringify(detail) });
    this.flushMessages();
  }

  // traceEvent(msg: string, property?: any): void {
  //   this.appInsightsService.trackEvent(this.app + msg, property)
  // }

  // traceException(err: Error): void {
  //   this.appInsightsService.trackException(err);
  // }

  // flushMessages() {
  //   this.appInsightsService.flush();
  // }

  traceException(err: Error): void {
    this.appInsights.trackException({ exception: err });
  }

  flushMessages() {
    this.appInsights.flush();
  }
  // -------- Tracing End -------

}
